<template>
  <el-dialog
      v-model="modelShow"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      draggable
      title="数据设置"
      width="1000px"
  >
    <el-tabs tab-position="left" v-model="setType">
      <template v-if="setConfig.code !== INDEX_DROP_TYPE.FILTER">
        <el-tab-pane v-for="(_item, index) in setConfig.config" :key="index" :label="_item.name" :name="_item.code">
          <InfoSet
              v-if="_item.code === INNER_CONFIG.FIELD"
              :option="option.prop"
              :item="item"
              :tem-data="temData"
          ></InfoSet>
          <BasicSet
              v-if="_item.code === INNER_CONFIG.BASIC_CONFIG"
              :option="option.prop"
              :compType="option.component?.prop"
              :item="item"
              :tem-data="temData"
          ></BasicSet>
          <FormatSet v-if="_item.code === INNER_CONFIG.FORMAT" :tem-data="temData"></FormatSet>
          <DateSet
              v-if="_item.code === INNER_CONFIG.TIME_SHIFT"
              :option="option.prop"
              :item="item"
              :tem-data="temData"
          ></DateSet>

          <AdvancedSet
              v-if="_item.code === INNER_CONFIG.ADVANCED_CALC"
              :option="option.prop"
              :item="item"
              :tem-data="temData"
          ></AdvancedSet>

          <IndexSet
              v-if="_item.code === INNER_CONFIG.INDEX_CONFIG"
              :option="option.prop"
              :item="item"
              :tem-data="temData"
          ></IndexSet>
          <ColumnSet
              v-if="_item.code === INNER_CONFIG.COLUMN"
              :option="option.prop"
              :item="item"
              :tem-data="temData"
          ></ColumnSet>
          <!--				option 当前大组件的配置 item当前配的维度或者指标项-->
          <Drill v-if="_item.code === INNER_CONFIG.DRILLING" :option="option.prop" :item="item" :tem-data="temData"/>
          <template v-if="_item.code === INNER_CONFIG.ADD_CONDITION">
            <el-button @click="cancelRule">重置条件</el-button>
            <ruleFilter
                :linkData="linkData"
                ref="rule"
                :data="conditions"
                :isPageVar="true"
                :level="1"
                :formDef="defaultForm"
                :selectArr="option.prop.rConditions"
            ></ruleFilter>
          </template>
        </el-tab-pane>
        <!--        报警暂时先屏蔽吧 应该暂时用不到-->
        <!--				<template v-if="dataSetType === 'alarm'">-->
        <!--					<el-tab-pane label="报警设置" name="8">-->
        <!--						<AlarmSet :tem-data="temData"></AlarmSet>-->
        <!--					</el-tab-pane>-->
        <!--				</template>-->
      </template>
      <el-tab-pane
          label="过滤条件配置"
          name="1"
          v-else
      >
        <form-item labelAlign="left" label="操作符">
          <el-select v-model="temData.oper" clearable size="small">
            <el-option
                v-for="item in operators"
                :label="item.name"
                :value="item.value"
                :key="item.value"
            ></el-option>
          </el-select>
        </form-item>
        <form-item
            v-if="item.fieldType === MODEL_COLUMN_TYPE.date"
            labelAlign="left"
            label="颗粒度"
        >
          <el-select v-model="temData.funcType" clearable size="small">
            <el-option
                v-for="item in dates"
                :label="item.name"
                :value="item.value"
                :key="item.value"
            ></el-option>
          </el-select>
        </form-item>
      </el-tab-pane>
    </el-tabs>
    <template #footer>
      <el-button type="primary" @click="confirm">确认</el-button>
      <el-button @click="cancel">取消</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import {useCommonMix} from "@/option/common/commonmix";
import {computed, inject, ref, useAttrs} from "vue";
import util from "@/option/common/util";
import {INDEX_DROP_TYPE, INNER_CONFIG, MODEL_COLUMN_TYPE} from "@/option/common/dict.js";
import FormatSet from "../valueFormat/formatSet.vue";
import BasicSet from "../valueFormat/basicSet.vue";
import DateSet from "../valueFormat/dateSet.vue";
import AdvancedSet from "../valueFormat/advancedSet.vue";
import JumpSet from "../valueFormat/jumpSet.vue";
import InfoSet from "../valueFormat/infoSet.vue";
import IndexSet from "../valueFormat/indexSet.vue";
import ColumnSet from "../valueFormat/columnSet.vue";
import Drill from "../valueFormat/drillSet.vue";
import AlarmSet from "../valueFormat/alarmSet.vue";
import {cloneDeep} from "lodash-es";
import ruleFilter from "./Rule.vue";
import conditionStyle from "./conditionStyle.vue";

const props = defineProps({
  modelValue: {},
  show: {},
  item: {},
  showIndexSet: {
    type: Boolean,
  },
  setConfig: {},
  linkData: {
    default() {
      return {};
    },
  },
  option: {},
  showDrill: {
    type: Boolean,
  },
});
let attr = useAttrs()
const defaultForm = {};
const conditions = ref({
  operationSymbol: "and",
  rows: [
    {
      ruletype: "d",
      id: "1",
    },
  ],
});
const rule = ref(null);
let filterDatas = ref({})
const emit = defineEmits(["update:modelValue", "update:show", "confirm"]);
const {success, warning, error} = useCommonMix();
//  暂存data
let temData = ref({});
temData.value = cloneDeep(props.modelValue);
if (temData.value?.filterDatas) {
  conditions.value = util.changeToComponentData(
      temData.value?.filterDatas,
      "conditions"
  );
}
let setType = ref(INNER_CONFIG.FIELD);
let modelShow = computed({
  get() {
    return props.show;
  },
  set(v) {
    emit("update:show", v);
  },
});

let dates = [
  {
    name: "年",
    value: "year",
  },
  {
    name: "月",
    value: "month",
  },
  {
    name: "日",
    value: "day",
  },
  {
    name: "时",
    value: "hour",
  },
  {
    name: "分",
    value: "minute",
  },
  {
    name: "秒",
    value: "second",
  },
];

function confirm() {
  submitRule()
  emit("update:modelValue", temData.value);
  emit("confirm", temData.value);
  modelShow.value = false;
}

function cancel() {
  modelShow.value = false;
}

let operators = computed(() => {
  return util.getOperatorByType(props.item.fieldType);
});

function cancelRule() {
  conditions.value = {
    operationSymbol: "and",
    rows: [
      {
        ruletype: "d",
        id: "1",
      },
    ],
  };
  filterDatas.value = {};
}

let pageArgs = inject('pageArgs', {})
let rootPageArgs = inject('rootPageArgs', {})
let pageParams = computed(() => {
  return pageArgs || rootPageArgs
})
let pageConfig = inject("pageConfig", {});
let datas = computed(() => {
  return pageConfig?.value?.schemaJson?.datas;
});

function submitRule() {
  if (!rule.value?.length) return;
  // 保存过滤条件
  filterDatas.value = rule.value[0].changeToFormData(
      conditions.value,
      "conditions"
  );
  util.handlerFilters(datas, [filterDatas.value], pageParams.value, props.linkData, attr)
  // 处理过滤条件的数据
  temData.value.filterDatas = filterDatas.value;
}

defineExpose({});
</script>

<style lang="scss" scoped>
@import "@/styles/variables";

.class-props-set {
  display: grid;
  padding: $gap;
  gap: $gap;
  grid-template-columns: repeat(auto-fill, 80px);

  .item-panel {
    cursor: pointer;
  }
}
</style>
